import { render } from "./TaxNitroReviewProcess.vue?vue&type=template&id=10d5f35b"
import script from "./TaxNitroReviewProcess.vue?vue&type=script&lang=ts"
export * from "./TaxNitroReviewProcess.vue?vue&type=script&lang=ts"
script.render = render

export default script